import React, { useState } from "react";
import "../css/Admin.css";
import AllProjects from "../components/Admin-Projects/AllProjects";
import AllEducation from "../components/Admin-Education/AllEducation";
import AllCourses from "../components/Admin-Courses/AllCourses";
import AllSkills from "../components/Admin-Skills/AllSkills";
import AllAwards from "../components/Admin-Awards/AllAwards";
import AllPhotoGallery from "../components/Admin-PhotoGallery/AllPhotoGallery";
import ProfileDetails from "../components/Admin-Profile/ProfileDetails";
import AdminMessages from "../components/Admin-Messages/AdminMessages";
import { Navigate, useNavigate } from "react-router-dom";

import { getAuth } from "firebase/auth";
import AllVolunteering from "../components/Admin-Volunteering/AllVolunteering";

const AdminDashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(""); // Track the current section
  const auth = getAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    auth.signOut();
    navigate("/"); 
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderContent = () => {
    switch (activeSection) {
      case "projects":
        return <AllProjects />;
      case "profile":
        return <ProfileDetails />;
      case "educations":
        return <AllEducation />;
      case "courses":
        return <AllCourses />;
      case "volunteering":
        return <AllVolunteering />;
      case "skills":
        return <AllSkills />;
      case "awards":
        return <AllAwards />;
      case "photoGallery":
        return <AllPhotoGallery />;
      case "messages":
        return <AdminMessages />;
      default:
        return;
    }
  };

  return (
    <div className="dashboard">
      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h2 style={{ color: "grey" }}>Admin Dashboard</h2>
          <button className="toggle-button" onClick={toggleSidebar}>
            ☰
          </button>
        </div>
        <ul className="sidebar-menu">
          <li
            className={activeSection === "profile" ? "active" : ""}
            onClick={() => setActiveSection("profile")}
          >
            Profile
          </li>
          <li
            className={activeSection === "skills" ? "active" : ""}
            onClick={() => setActiveSection("skills")}
          >
            Skills
          </li>
          <li
            className={activeSection === "educations" ? "active" : ""}
            onClick={() => setActiveSection("educations")}
          >
            Educations
          </li>
          <li
            className={activeSection === "courses" ? "active" : ""}
            onClick={() => setActiveSection("courses")}
          >
            Courses
          </li>
          <li
            className={activeSection === "volunteering" ? "active" : ""}
            onClick={() => setActiveSection("volunteering")}
          >
            Volunteering
          </li>
          <li
            className={activeSection === "awards" ? "active" : ""}
            onClick={() => setActiveSection("awards")}
          >
            Awards
          </li>
          <li
            className={activeSection === "projects" ? "active" : ""}
            onClick={() => setActiveSection("projects")}
          >
            Projects
          </li>
          <li
            className={activeSection === "photoGallery" ? "active" : ""}
            onClick={() => setActiveSection("photoGallery")}
          >
            Photo Gallery
          </li>
          <li
            className={activeSection === "messages" ? "active" : ""}
            onClick={() => setActiveSection("messages")}
          >
            Messages
          </li>
        </ul>
      </aside>
      <main className="main-content">
        <header className="main-header">
          <button className="toggle-button mobile-only" onClick={toggleSidebar}>
            ☰
          </button>
          <h1
            style={{ textAlign: "center", color: "orange", fontWeight: "900" }}
          >
            Welcome Kushan
          </h1>
          <button
            className="toggle-button"
            style={{
              backgroundColor: "orange",
              padding: "10px",
              borderRadius: "30px",
              color: "black",
              fontWeight: "900",
              fontSize: "20px",
            }}
            onClick={onLogout}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "darkred";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "orange";
              e.target.style.color = "black";
            }}
          >
            Logout
          </button>
        </header>
        <section className="content">{renderContent()}</section>
      </main>
    </div>
  );
};

export default AdminDashboard;
